import { View, tokens, type SapphireStyleProps } from '@sapphire-react/core';

type Props = {
  marginBottom?: SapphireStyleProps['marginBottom'];
  marginTop?: SapphireStyleProps['marginTop'];
};

export function FormDivider({
  marginBottom = tokens.size.spacingMd,
  marginTop = tokens.size.spacingMd,
}: Props) {
  return (
    <View
      height={1}
      width={'100%'}
      marginBottom={marginBottom}
      marginTop={marginTop}
      backgroundColor={tokens.color.borderSecondary.value}
    />
  );
}
